import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-logo-circle" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-take-pic" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bottom_pop_up_item = _resolveComponent("bottom-pop-up-item")!
  const _component_app_bottom_pop_up = _resolveComponent("app-bottom-pop-up")!

  return (_ctx.isOpen)
    ? (_openBlock(), _createBlock(_component_app_bottom_pop_up, {
        key: 0,
        onHide: _ctx.hidePopUp,
        "hide-bottom-decoration": "",
        "hide-top-decoration": ""
      }, {
        title: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$localize('message.photo.selector.popup.title')), 1)
        ]),
        body: _withCtx(() => [
          _createVNode(_component_bottom_pop_up_item, { onClick: _ctx.openDriveMedia }, {
            icon: _withCtx(() => [
              _hoisted_1
            ]),
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$localize('message.photo.selector.popup.casedrive')) + " ", 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_bottom_pop_up_item, { onClick: _ctx.openPhoneMedia }, {
            icon: _withCtx(() => [
              _hoisted_2
            ]),
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$localize('message.file.selector.popup.upload.photo_type')) + " ", 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      }, 8, ["onHide"]))
    : _createCommentVNode("", true)
}